import $ from 'cash-dom';
import BaseField from './BaseField';

class SelectboxField extends BaseField {
	constructor($input) {
		super($input);

		this._$selectBoxes = this._$input.find('.filter-holder');
		this._setCurrentData(this._$input.find('.filter-holder.selected'));

		this._handleSelect();

		this._$input.on('change-input', this._handleChange);
	}

	_setCurrentData($currentSelectbox) {
		this._$input.data('vendors', $currentSelectbox.data('vendors'));
		const deeplinks = typeof $currentSelectbox.data('deeplinks') === 'undefined' ? null : $currentSelectbox.data('deeplinks');
		this._$input.data('deeplinks', deeplinks);

		this._value = $currentSelectbox.attr('value');
		this._label = $currentSelectbox.find('.label').text().trim();
	}

	_handleSelect() {
		const self = this;

		self._$selectBoxes.on('click', function () {
			const $currentSelectbox = $(this);

			self._$selectBoxes.removeClass('selected');
			$currentSelectbox.addClass('selected');

			self._setCurrentData($currentSelectbox);

			self._$input.trigger('change-input', $currentSelectbox);
		})
	}

	_handleChange = (e, $currentSelectbox) => {
		const redirectLink = $currentSelectbox.data('link');

		if (redirectLink) {
			$(document).trigger(BaseField.EVENT_FILTER_FIELD_CHANGE, {
				redirectLink,
				filterName: this._getName(),
				currentFieldValue: this.getValue(),
			});
			return;
		}

		$(document).trigger(BaseField.EVENT_FILTER_FIELD_CHANGE, {
			filterName: this._getName(),
			currentFieldValue: this.getValue(),
		});
	}

	/**
	 * @inheritDoc
	 * @private
	 */
	_getLabel() {
		return this._label;
	}

	getValue() {
		return this._value;
	}

	setValue(filterValue) {
		this.setValueAndTriggerEvent(filterValue);
	}

	/**
	 * @inheritDoc
	 * @param {string|any} filterValue
	 */
	setValueAndTriggerEvent(filterValue) {
		this._value = filterValue;
		this._$input.find('.filter-holder[value="' + filterValue + '"]').trigger('click');
	}
}

export default SelectboxField;
